import React from "react";
import { MODEL_KEY } from "config/products";
import WatchUltra4Detail from "./WatchUltra4Detail";

function WatchUltra4() {
  return <WatchUltra4Detail modelId={MODEL_KEY.WATCHULTRA4} />;
}

export default WatchUltra4;
